import React, {useState, useRef, useEffect} from 'react';
import {useRouter} from 'next/router';
import { useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Loading from '../../elements/Loading';
import styles from '../../styles/elements/Form.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faExclamation, faCaretLeft } from '@fortawesome/free-solid-svg-icons';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Typeahead} from 'react-bootstrap-typeahead';
import axios from 'axios';
import useInputState from '../../hooks/forms/useInputState';
import SetRating from './SetRating';
import {FormChecker, ScrollToError} from '../../utils/validation/FormValidator';
import {TextValidator, TextOnlyValidator, SelectField} from '../../utils/validation/GeneralValidators';
import ErrorMessage from '../../elements/ErrorMessage';
import SuccessMessage from '../../elements/SuccessMessage';
import { reset } from '../../login/userSlice';


const CreateReview = (props) => {

    const initValidState = {
        company: {help: '', field: '', error: false},
        product: {help: '', field: '', error: false},
        newCompany: {help: '', field: '', error: false},
        newProduct: {help: '', field: '', error: false},
        rating: {help: '', field: '', error: false},
        comment: {help: '', field: '', error: false},
        title: {help: '', field: '', error: false},
    };
    const router = useRouter();
    const {currentReviewId, goToProfile, showList} = props;
    const isMounted = useRef(null);
    const dispatch = useDispatch();

    const [company, editCompany] = useState([]);
    const [product, editProduct] = useState([]);
    const [newCompany, editNewCompany, resetNewCompany] = useInputState();
    const [newProduct, editNewProduct, resetNewProduct] = useInputState();
    const [comment, editComment] = useState('');
    const [title, editTitle] = useState('');
    const [showNewCompany, editShowNewCompany] = useState(false);
    const [showNewProduct, editShowNewProduct] = useState(false);
    const [rating, editRating] = useState(0);
    const [acceptContact, editAcceptContact] = useState(false);
    const [ratingError, editRatingError] = useState(false);
    const [isValid, editIsValid] = useState(initValidState);
    const [error, editError] = useState(false);
    const [isLoadingResult, editIsLoadingResult] = useState(false);
    const [isComplete, editIsComplete] = useState(false);
    const [isLoadingReview, editIsLoadingReview] = useState(false);

    //select options
    const [companies, editCompanies] = useState([]);
    const [products, editProducts] = useState([]);

    useEffect( ()=>{
        isMounted.current = true;
        editIsLoadingReview(true);
        loadData();
        return ()=>{
            isMounted.current = false;
        }
    }, []);

    useEffect( ()=>{
        loadReview();
    }, [companies, products]
    )

    const importReview = (info) => {
      
        editAcceptContact(info.acceptContact);
        let selectedProduct = products.find( p => p.name == info.product);
        if (selectedProduct) {
            editProduct([selectedProduct]);
        }
        let selectedCompany = companies.find( p => p.name == info.provider);
        if (selectedCompany) {
            editCompany([selectedCompany]);
        }
        editRating(info.rating);
        editComment(info.review);
        editTitle(info.title);
        
    }

    const loadData = async () => {
        axios.get( process.env.NEXT_PUBLIC_API + '/api/resources/review/providers/list', 
            { headers: {  'Content-Type': 'application/json'},})
        .then(
            response =>{
                let data = response.data;
                if (data.status) {
                    if (isMounted.current) {
                        editCompanies(data.list);
                    }
                }
                return axios.get(process.env.NEXT_PUBLIC_API + '/api/resources/review/products/list', {
                    headers: {  'Content-Type': 'application/json'},
                })
        })
        .then( response => {
            let data = response.data;
            if (data.status) {
                if (isMounted.current) {
                    editProducts(data.list);
                }
            }
        })
        .catch(error => {
            
        })
    }

    const loadReview  = async () => {
        
        if (companies.length>0 && products.length>0 ) {
            try {
                let response  = await axios.get(process.env.NEXT_PUBLIC_API + '/api/user/review/item',{
                    params: {id: currentReviewId},
                    headers: {  'Content-Type': 'application/json'},
                    withCredentials: true,
                });
                let data = response.data;
                if (data.status) {
                    if (isMounted.current) {
                        importReview(data.details);
                    }
                } else {
                    if (data.hasOwnProperty('error')) {
                        if (data.error == 'login') {
                            router.push('/login');
                        }
                    }
                }
            } catch (err) {
                
            }
            editIsLoadingReview(false);
        }
        
    }

    //load validation rules for fields
    const ValidationRules = {
        company: SelectField,
        product: SelectField,
        newCompany: {rule: TextValidator, param: 3 },
        newProduct: {rule: TextOnlyValidator, param: 3 },
        title: {rule: TextValidator, param: 2 },
        comment: {rule: TextValidator, param: 2 },
    };

    //blur validation
    const validateFieldOnBlur = (e) => {
       
        const field = e.target;
        let value = field.value;
        const id= e.target.id;
        
        let res;
        if (typeof ValidationRules[id] == 'object') {
            res = ValidationRules[id].rule(value, ValidationRules[id].param);
        } else {
            res = ValidationRules[id](value);
        }
       
        if (id=='product'&& res.status) {
            if (!productInList(value)) {
                res = {
                    status: false,
                    msg: 'Alege un produs din listă'
                };
            }
        }

        if (id=='company'&& res.status) {
            if (!companyInList(value)) {
                res = {
                    status: false,
                    msg: 'Alege o instituție din listă'
                };
            }
        }

        editIsValid(
            {  ...isValid, 
                [id] : {
                    help: res.status ? 'valid-feeback' : 'invalid-feedback',
                    field: res.status ? 'is-valid' : 'is-invalid',
                    error: res.msg
                }
            }
        );
    }

    const companyInList = (name) => {
        const response = companies.find( c => c.name == name);
        if (!response) {
            return false;
        } 
        return true;
    }

    const productInList = (name) => {
        const response = product.find( c => c.name == name);
        if (!response) {
            return false;
        } 
        return true;
    }

    const toggleProductField = () => { editShowNewProduct(!showNewProduct)};
    const toggleCompanyField = () => { editShowNewCompany(!showNewCompany)};

    const companyField = !showNewCompany &&
                        <Row>
                            <Col lg={6} >
                                <Form.Group className="mb-0">
                                    <Form.Label>Instituția financiară</Form.Label>    
                                    <Typeahead
                                        id="company"
                                        labelKey="company"
                                        onChange={editCompany}
                                        options={companies}
                                        placeholder="Alege o instituție..."
                                        selected={company}
                                        labelKey="name"
                                        emptyLabel="Niciun rezultat" 
                                        onBlur = {validateFieldOnBlur}
                                        inputProps={
                                           { id: 'company', name: 'company' }
                                        }
                                        className={isValid.company.field}
                                        clearButton={true}
                                    />
                                    <Form.Text className={`helper ${isValid.company.help}`} as="div">
                                            {isValid.company.error}
                                    </Form.Text> 
                                </Form.Group>
                                <p className={`${styles.smallInfo} text-muted mt-0`}>
                                    Nu ai găsit furnizorul? <span className={styles.textLink} onClick={toggleCompanyField}>Propune o nouă opțiune</span>
                                </p>
                            </Col>   
                        </Row>;

    const productField = !showNewProduct &&
                        <Row>
                            <Col lg={6}>
                                <Form.Group className="mb-0">
                                    <Form.Label>Produsul utilizat</Form.Label>             
                                    <Typeahead
                                        type="text" 
                                        id="product"
                                        name="product"
                                        selected={product}
                                        onChange={editProduct}
                                        placeholder="Alege un produs"
                                        labelKey="name"
                                        options={products}
                                        emptyLabel="Niciun rezultat"
                                        onBlur = {validateFieldOnBlur}
                                        inputProps={
                                            { id: 'product', name: 'product' }
                                         }
                                        className={isValid.product.field}
                                        clearButton={true}
                                    />
                                    <Form.Text className={`helper ${isValid.product.help}`} as="div">
                                        {isValid.product.error}
                                    </Form.Text> 
                                </Form.Group>
                                <p className={`${styles.smallInfo} text-muted mt-0`}>
                                    Nu ai găsit produsul? <span className={styles.textLink} onClick={toggleProductField}>Propune o nouă opțiune</span>
                                </p>
                            </Col>
                        </Row>;

    const newProductField = showNewProduct &&
                        <Row>
                            <Col lg={6}>
                                <Form.Group className="mb-0">
                                    <Form.Label>
                                    Produsul propus
                                    </Form.Label>    
                                    <Form.Control
                                        id="newProduct"
                                        name="newProduct"
                                        onChange={editNewProduct}
                                        placeholder="Denumire produs..."
                                        onBlur={validateFieldOnBlur}
                                        className={isValid.newProduct.field}
                                    />
                                    <Form.Text className={`helper ${isValid.newProduct.help}`} as="div">
                                        {isValid.newProduct.error}
                                    </Form.Text> 
                                    <p className={`${styles.smallInfo} ${styles.textLink} mt-0`} onClick={toggleProductField}>
                                        <FontAwesomeIcon icon={faCaretLeft} height="16" width="16" className="me-2"/>
                                        Înapoi la lista de opțiuni
                                    </p>
                                </Form.Group>
                            </Col>
                        </Row>;

    const newCompanyField = showNewCompany &&
                        <Row>
                            <Col lg={6}>
                                <Form.Group className="mb-0">
                                    <Form.Label>
                                    Instituția financiară propusă
                                    </Form.Label>    
                                    <Form.Control
                                        id="newCompany"
                                        name="newCompany"
                                        onChange={editNewCompany}
                                        placeholder="Denumire instituție..."
                                        onBlur={validateFieldOnBlur}
                                        className={isValid.newCompany.field}
                                    />
                                    <Form.Text className={`helper ${isValid.newCompany.help}`} as="div">
                                        {isValid.newCompany.error}
                                    </Form.Text>
                                </Form.Group>
                                <p className={`${styles.smallInfo} ${styles.textLink} mt-0`} onClick={toggleCompanyField}>
                                    <FontAwesomeIcon icon={faCaretLeft} height="16" width="16" className="me-2"/>
                                    Înapoi la lista de opțiuni
                                </p>
                            </Col>
                        </Row>;

    const setTitle = (e) => { editTitle(title.length<=40 ? e.target.value : title);}
    const setComment = (e)=>{
        editComment(e.target.value);
        if ( (title.length<40) && (title=='' || title==comment) ) {
            editTitle(e.target.value); 
        }
    }        

    const commentField =    <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                          Spune-ne despre experiența avută
                                        </Form.Label>  
                                        <Form.Control as="textarea" rows={5}
                                            id="comment"
                                            name="comment"
                                            onChange={setComment}
                                            value={comment}
                                            onBlur={validateFieldOnBlur}
                                            className={isValid.comment.field}
                                            placeholder="Aici îți poți scrie recenzia. Scrie despre ce s-a întâmplat și evită cuvintele ofensive. Prezintă parerea ta într-un mod onest și util ..."
                                        />  
                                        <Form.Text className={`helper ${isValid.comment.help}`} as="div">
                                            {isValid.comment.error}
                                        </Form.Text> 
                                    </Form.Group>   
                                </Col>
                            </Row>;


    const titleField =    <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                          Dă un titlu recenziei
                                        </Form.Label>  
                                        <Form.Control 
                                            id="title"
                                            name="title"
                                            onChange={setTitle}
                                            value={title}
                                            onBlur={validateFieldOnBlur}
                                            className={isValid.title.field}
                                            placeholder="Scrie un titlu pentru recenzie ..."
                                        />  
                                        <Form.Text className={`helper ${isValid.title.help}`} as="div">
                                            {isValid.title.error ? isValid.title.error :
                                            (title.length==0 ? 'Maxim 40 caractere' : `Au mai ramas ${40 - title.length} caractere`)
                                             }
                                        </Form.Text> 
                                    </Form.Group>   
                                </Col>
                            </Row>;
    
    const setScore = (val) => { editRating(val); editRatingError(false)};
    const ratingScale = ['Selecteaza nota', 'Slab', 'Satisfacator', 'Bun', 'Foarte bun', 'Excelent'];
    const ratingInfo  = rating==0 ? ratingScale[0] : 'Calificativ: ' + ratingScale[rating];

    const setAcceptContact = (e) => { editAcceptContact(e.target.checked);}

    const contactField = <Row className="my-3">
                            <Col>
                                <Form.Group className="" >
                                    <Form.Check type="checkbox" custom label="" className=""
                                        checked={acceptContact}
                                        onChange={setAcceptContact } 
                                        id="acceptContact"
                                        name="acceptContact"
                                        custom
                                        label="Sunt de acord sa fiu contactat de instituția financiară pentru a discuta despre recenzie"
                                    />
                                    <Form.Text className="helper" as="div">    
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>;

    const checkRatingSelection = () => {
        
        if (rating==0) {
            editRatingError('Alege o opțiune');
            return false;
        } else {
            editRatingError(false);
            return true;
        }
    }

    const endMessageText  = currentReviewId > 0 ?
                            {
                                title: 'Perfect!',
                                message: 'Am salvat modificarile tale.'
                            }
                            :
                            {
                                title: 'Felicitări',
                                message: 'Recenzia a fost postată cu succes.'
                            };

    const endReview = isComplete && <SuccessMessage 
                        title={endMessageText.title} 
                        message={endMessageText.message}
                        onClose={showList}
                    />;
    
    const saveReview = async (e) =>{
        e.preventDefault();
        editError(false);
        editIsLoadingResult(true);
        let validForm = FormChecker('reviewForm', ValidationRules );
        let checkRating = checkRatingSelection();
    
        if (validForm.status && checkRating) {
            try {
                let url = process.env.NEXT_PUBLIC_API + '/api/user/review/create';
                const response = await axios({
                    url: url,
                    method: 'post',
                    withCredentials: true,
                    data: {
                        id: currentReviewId,
                        comment,
                        title,
                        rating,
                        company: company.length>0 ? company[0].id : false,
                        newCompany,
                        product: product.length>0 ? product[0].id : false,
                        newProduct,
                        acceptContact
                    },
                    headers: {'Content-Type': 'application/json'},
                });

                let data = response.data;
                if (isMounted.current) {
                    if (data.status) {
                        editIsComplete(true);
                    } else {      
                        if (data.step=='profile') {
                            goToProfile();
                        } else if (data.hasOwnProperty('error') ) {

                            if (data.error == 'login') {
                                dispatch(reset());
                            } else {
                                let errors = {};
                                for (const prop in data.error) {
                                    errors[prop] = {
                                                help: 'invalid-feedback',
                                                field: 'is-invalid',
                                                error: data.error[prop]
                                            };
                                }
                                editIsValid({ ...isValid, ...errors});
                                ScrollToError('reviewForm');
                            }
                            

                        } else {
                            editError(data.message);
                        }    
                    }
                    editIsLoadingResult(false);
                }
                

            } catch (err) {
                editError('Te rugam sa incerci mai tarziu.')  
                editIsLoadingResult(false);     
            }

        } else {
           
            editIsValid(validForm.data);
            ScrollToError('reviewForm');
            editIsLoadingResult(false);
        }

    }

    return (
        <>
            <Row className="g-0">
                <Col lg={8} xs={12} className="mx-auto">
                    <h1 className="heading1 py-3 font-weight-bold text-center black-text">
                    { currentReviewId == 0 ? 'Adaugă recenzie' : 'Editează recenzia'}
                    </h1>
                
                </Col>
            </Row>
            {isLoadingReview ? <Loading /> 
            :
            <Row className="bg-white py-3 px-3 g-0">
                <Col lg={8} xs={12} className="mx-auto">

                    <Form id="reviewForm" className={`${styles.root} ${styles.boldLabel}`} onSubmit={saveReview}>
                        <p className="heading2 font-weight-bold mt-3 mb-0 green">Produsul evaluat</p>
                        {companyField}
                        {newCompanyField}
                        {productField}
                        {newProductField}                     

                        <p className="heading2 font-weight-bold mt-3 mb-0 green">Experiența avută</p>
                        <Row className="my-3">
                            <Col>
                                <p className={`${styles.smallInfo} font-weight-bold`} >Acordă o notă</p>
                                <SetRating score={rating} setScore={setScore} />
                                
                                <Form.Text className={`helper ${ratingError ? 'd-block invalid-feedback' : ''}`} as="div">
                                    {ratingError ? ratingError : ratingInfo}
                                </Form.Text>
                               
                            </Col>
                        </Row>

                        {commentField}
                        <p className={`${styles.smallInfo} font-italic text-muted`} >
                        <FontAwesomeIcon icon={faExclamation} height="16" width="16" className="me-2 red"/>
                            Important: Nu completa date personale (email, telefon, CNP, etc) în câmpul de descriere, deoarece recenzia va deveni publică.
                        </p>

                        {titleField}
                        {contactField}
                        {isLoadingResult ? 
                        <div className="text-center">
                            <Spinner animation="border" className="green my-3" />
                        </div>
                        :
                        <Button variant="primary" type="submit" className="col-12"  >
                                <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="me-1"/>
                                Postează
                        </Button>
                        }       
                        
                    </Form>
                    {error && <ErrorMessage title="Eroare" message={error} />}
                </Col>
            </Row>
            }
            {endReview}
        </>
    );
}

export default CreateReview;